import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="employee";
export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter
  })
}
export function selectUsersByAccountIds(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectUsersByAccountIds`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

/**
 * 伙伴选择
 * @param parameter
 */
export function selectUsers(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectUsers`,
    method: 'get',
    params: parameter
  })
}

/**
 * 伙伴选择
 * @param parameter
 */
export function selectUsersByDeduction(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectUsersByDeduction`,
    method: 'get',
    params: parameter
  })
}

/**
 * 伙伴选择
 * @param parameter
 */
export function selectBusinessUsers(){
  return axios({
    url: `/ws/${moduleName}/selectBusinessUsers`,
    method: 'get',
  })
}

/**
 * 伙伴选择
 * @param parameter
 */
export function selectAllUsers(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllUsers`,
    method: 'get',
    params: parameter
  })
}

/**
 * 伙伴选择
 * @param parameter
 */
export function selectUsersByDepId(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectUsersByDepId`,
    method: 'get',
    params: parameter
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}

export function selectLogin(){

  return axios({
    url: `/ws/${moduleName}/selectLogin`,
    method: 'get'
  })
}

export function selectByAaccountId(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectByAaccountId/${parameter}`,
    method: 'get'
  })
}


export function getFormToken(){
  return axios({
    url: `/ws/${moduleName}/getFormToken`,
    method: 'get'
  })
}

export function getEmpNextNumber(companyId){
  return axios({
    url: `/ws/${moduleName}/getEmpNextNumber`,
    method: 'get',
    params:{companyId:companyId}
  })
}


export function selectUserAuth(id){
  return axios({
    url: `/ws/${moduleName}/selectUserAuth/${id}`,
    method: 'get'
  })
}


export function getBirthDayEmployee(){
  return axios({
    url: `/ws/${moduleName}/getBirthDayEmployee`,
    method: 'get'
  })
}



export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export function beRegular(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/beRegular`,
    method: 'post',
    data:parameter
  })
}
export function getYearLeave(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/getYearLeave`,
    method: 'post',
    data:parameter
  })
}



export function getCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/getCompanyInfo`,
    method: 'get'
  })
}


export function getStatisticsCompanyInfo(tableName){
  return axios({
    url: `/ws/${moduleName}/getStatisticsCompanyInfo/${tableName}`,
    method: 'get'
  })
}

export function getDepStatisticsCompanyInfo(tableName){
  return axios({
    url: `/ws/${moduleName}/getDepStatisticsCompanyInfo/${tableName}`,
    method: 'get'
  })
}


export function getLoginCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/getLoginCompanyInfo`,
    method: 'get'
  })
}



export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function closeSelectInsights(){
  return axios({
    url: `/ws/${moduleName}/closeSelectInsights`,
    method: 'put',
  })
}
export function updateUserAuth(id,parameter){
  console.log("data:",parameter,id)
  return axios({
    url: `/ws/${moduleName}/updateUserAuth/${id}`,
    method: 'put',
    data:parameter
  })
}


export function unlock(accountId){
  console.log("data:",accountId)
  return axios({
    url: `/ws/${moduleName}/unlock/${accountId}`,
    method: 'put',
  })
}



export function lock(accountId){
  console.log("data:",accountId)
  return axios({
    url: `/ws/${moduleName}/lock/${accountId}`,
    method: 'put',
  })
}

export function selectQuitUserNextUser(accountId){
  console.log("data:",accountId)
  return axios({
    url: `/ws/${moduleName}/selectQuitUserNextUser/${accountId}`,
    method: 'get',
  })
}

export function quit(datas){
  console.log("data:",datas)
  return axios({
    url: `/ws/${moduleName}/quit`,
    method: 'put',
    data:datas
  })
}

export function resetPassword(accountId){
  console.log("data:",accountId)
  return axios({
    url: `/ws/${moduleName}/resetPassword/${accountId}`,
    method: 'put',
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids
  })
}



export function updateEmployeeHomeUrl(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateEmployeeHomeUrl`,
    method: 'put',
    data:parameter
  })
}


export function updateHomeNewsValue(homeNewsValue){
  console.log("homeNewsValue:",homeNewsValue)
  return axios({
    url: `/ws/${moduleName}/updateHomeNewsValue`,
    method: 'put',
    params: {homeNewsValue:homeNewsValue}
  })
}


export function exportEmployeeAll(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/export/exportEmployeeAll`,
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

export default {
  selectAll,
  getCompanyInfo,
  getStatisticsCompanyInfo,
  getDepStatisticsCompanyInfo,
  getLoginCompanyInfo,
  selectUsersByDepId,
  selectUserAuth,
  selectOne,
  selectByAaccountId,
  selectUsers,
  selectAllUsers,
  save:insert,
  update,
  lock,
  getFormToken,
  unlock,
  quit,
  updateUserAuth,
  resetPassword,
  delete:deleteObj,
  getEmpNextNumber,
  selectUsersByAccountIds,
  getBirthDayEmployee,
  exportEmployeeAll,
  selectQuitUserNextUser,
  updateEmployeeHomeUrl,
  closeSelectInsights,
  selectLogin,
  beRegular,
  updateHomeNewsValue,
  getYearLeave,
  selectUsersByDeduction,
  selectBusinessUsers
}